export const handleSelectFocus = (event: Event) => {
  const select = event.target as HTMLSelectElement;
  
  // Track if user actually changed the value
  let valueChanged = false;
  const changeHandler = () => {
    valueChanged = true;
    cleanup();
  };
  
  const cleanup = () => {
    document.removeEventListener('touchstart', touchHandler, true);
    document.removeEventListener('click', clickHandler, true);
    select.removeEventListener('change', changeHandler);
    select.removeEventListener('blur', blurHandler);
  };
  
  // Clean up when select loses focus naturally
  const blurHandler = () => {
    cleanup();
  };
  
  // Handle touch events (for iPad)
  const touchHandler = (touchEvent: Event) => {
    const target = touchEvent.target as HTMLElement;
    if (target !== select && document.activeElement === select) {
      requestAnimationFrame(() => {
        if (!valueChanged && document.activeElement === select) {
          select.blur();
        }
      });
    }
  };
  
  // Handle clicks (for desktop/other devices)
  const clickHandler = (clickEvent: Event) => {
    const target = clickEvent.target as HTMLElement;
    if (target !== select && document.activeElement === select) {
      requestAnimationFrame(() => {
        if (!valueChanged && document.activeElement === select) {
          select.blur();
        }
      });
    }
  };
  
  // Add event listeners
  select.addEventListener('change', changeHandler);
  select.addEventListener('blur', blurHandler);
  document.addEventListener('touchstart', touchHandler, true);
  document.addEventListener('click', clickHandler, true);
};

export const handleSelectChange = (event: Event) => {
  const select = event.target as HTMLSelectElement;
  // Blur immediately when selection is made
  requestAnimationFrame(() => select.blur());
};
